export default "<div id=\"{{::$ctrl.id}}\" class=\"accordion\" ng-transclude></div>"